import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiGift } from 'react-icons/fi';

const features = [
  "Main 'Emergency Numbers' Design with detailed scripture references.",
  "3 BONUS Alternate elegant scripture designs ($15 Value).",
  "5 BONUS Bible-themed art designs ($25 Value).",
  "High-resolution files ready for crisp, clear printing.",
  "Scale to any size (default is ~2\" x 6\")."
];

const IncludedSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4">A Complete Collection of 9 Designs</h2>
          <p className="text-lg text-stone-600">Your digital bundle includes the primary scripture guide plus 8 premium bonus designs to mix and match.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1 relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-stone-100 rounded-xl overflow-hidden shadow-md transform translate-y-4 h-[400px]">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/fe8c05ea88e0448a8ae1ba948e39ed83.png" 
                  alt="Hand holding three alternate bookmark designs" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="bg-stone-100 rounded-xl overflow-hidden shadow-md transform -translate-y-4 h-[400px]">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/cf1fc522d02368a5c31126dad377e602.png" 
                  alt="Spread showing bonus art designs" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-amber-500 p-4 rounded-full shadow-xl">
              <SafeIcon icon={FiGift} className="text-3xl text-white" />
            </div>
          </div>

          <div className="order-1 md:order-2 space-y-8">
            <div className="inline-block bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-widest mb-2">
              Bundle Value: $45.00
            </div>
            <h3 className="text-2xl font-bold text-stone-900 border-b border-stone-200 pb-4">What's inside your download:</h3>
            <ul className="space-y-4">
              {features.map((feature, index) => (
                <li key={index} className="flex gap-4">
                  <SafeIcon icon={FiCheckCircle} className="text-amber-500 text-xl flex-shrink-0 mt-0.5" />
                  <span className="text-stone-700 text-lg">{feature}</span>
                </li>
              ))}
            </ul>
            
            <div className="p-6 bg-amber-50 rounded-xl border border-amber-100">
              <p className="text-stone-600 text-sm mb-2 uppercase tracking-wide font-bold">Designer Note</p>
              <p className="text-amber-800 font-medium italic">
                "This bundle gives you 4 unique scripture designs and 5 beautiful bible-themed art pieces. Mix and match to create double-sided bookmarks or standalone gifts!"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IncludedSection;